'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024$0024anon$00247 from "./presto.types$-Dashboard-Period$$anon$7.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardPeriod$$anon$8(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DashboardPeriod$$anon$8 as $c_Lpresto_types$DashboardPeriod$$anon$8 };
$p = $c_Lpresto_types$DashboardPeriod$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardPeriod$$anon$8;
/** @constructor */
function $h_Lpresto_types$DashboardPeriod$$anon$8() {
}
export { $h_Lpresto_types$DashboardPeriod$$anon$8 as $h_Lpresto_types$DashboardPeriod$$anon$8 };
$h_Lpresto_types$DashboardPeriod$$anon$8.prototype = $p;
$p.bN = (function(str) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$DashboardPeriod$().cR2(str));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(t.l());
});
var $d_Lpresto_types$DashboardPeriod$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardPeriod$$anon$8, "presto.types$DashboardPeriod$$anon$8", ({
  Zh: 1,
  K: 1
}));
export { $d_Lpresto_types$DashboardPeriod$$anon$8 as $d_Lpresto_types$DashboardPeriod$$anon$8 };
function $s_Lpresto_types$DashboardPeriod$__Last6h__Lpresto_types$DashboardPeriod() {
  $m_Lpresto_types$DashboardPeriod$();
  return $t_Lpresto_types$DashboardPeriod$__Last6h;
}
export { $s_Lpresto_types$DashboardPeriod$__Last6h__Lpresto_types$DashboardPeriod as $s_Lpresto_types$DashboardPeriod$__Last6h__Lpresto_types$DashboardPeriod };
function $s_Lpresto_types$DashboardPeriod$__Last12h__Lpresto_types$DashboardPeriod() {
  $m_Lpresto_types$DashboardPeriod$();
  return $t_Lpresto_types$DashboardPeriod$__Last12h;
}
export { $s_Lpresto_types$DashboardPeriod$__Last12h__Lpresto_types$DashboardPeriod as $s_Lpresto_types$DashboardPeriod$__Last12h__Lpresto_types$DashboardPeriod };
function $s_Lpresto_types$DashboardPeriod$__Last24h__Lpresto_types$DashboardPeriod() {
  $m_Lpresto_types$DashboardPeriod$();
  return $t_Lpresto_types$DashboardPeriod$__Last24h;
}
export { $s_Lpresto_types$DashboardPeriod$__Last24h__Lpresto_types$DashboardPeriod as $s_Lpresto_types$DashboardPeriod$__Last24h__Lpresto_types$DashboardPeriod };
function $s_Lpresto_types$DashboardPeriod$__Last48h__Lpresto_types$DashboardPeriod() {
  $m_Lpresto_types$DashboardPeriod$();
  return $t_Lpresto_types$DashboardPeriod$__Last48h;
}
export { $s_Lpresto_types$DashboardPeriod$__Last48h__Lpresto_types$DashboardPeriod as $s_Lpresto_types$DashboardPeriod$__Last48h__Lpresto_types$DashboardPeriod };
function $s_Lpresto_types$DashboardPeriod$__Last7d__Lpresto_types$DashboardPeriod() {
  $m_Lpresto_types$DashboardPeriod$();
  return $t_Lpresto_types$DashboardPeriod$__Last7d;
}
export { $s_Lpresto_types$DashboardPeriod$__Last7d__Lpresto_types$DashboardPeriod as $s_Lpresto_types$DashboardPeriod$__Last7d__Lpresto_types$DashboardPeriod };
function $s_Lpresto_types$DashboardPeriod$__Last30d__Lpresto_types$DashboardPeriod() {
  $m_Lpresto_types$DashboardPeriod$();
  return $t_Lpresto_types$DashboardPeriod$__Last30d;
}
export { $s_Lpresto_types$DashboardPeriod$__Last30d__Lpresto_types$DashboardPeriod as $s_Lpresto_types$DashboardPeriod$__Last30d__Lpresto_types$DashboardPeriod };
/** @constructor */
function $c_Lpresto_types$DashboardPeriod$() {
  this.c55 = null;
  this.c56 = false;
  this.c57 = null;
  this.c58 = false;
  $n_Lpresto_types$DashboardPeriod$ = this;
  $t_Lpresto_types$DashboardPeriod$__Last6h = new $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024$0024anon$00247.$c_Lpresto_types$DashboardPeriod$$anon$7(0, "Last6h", this);
  $t_Lpresto_types$DashboardPeriod$__Last12h = new $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024$0024anon$00247.$c_Lpresto_types$DashboardPeriod$$anon$7(1, "Last12h", this);
  $t_Lpresto_types$DashboardPeriod$__Last24h = new $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024$0024anon$00247.$c_Lpresto_types$DashboardPeriod$$anon$7(2, "Last24h", this);
  $t_Lpresto_types$DashboardPeriod$__Last48h = new $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024$0024anon$00247.$c_Lpresto_types$DashboardPeriod$$anon$7(3, "Last48h", this);
  $t_Lpresto_types$DashboardPeriod$__Last7d = new $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024$0024anon$00247.$c_Lpresto_types$DashboardPeriod$$anon$7(4, "Last7d", this);
  $t_Lpresto_types$DashboardPeriod$__Last30d = new $j_presto$002etypes$0024$002dDashboard$002dPeriod$0024$0024anon$00247.$c_Lpresto_types$DashboardPeriod$$anon$7(5, "Last30d", this);
  $s_Lpresto_types$DashboardPeriod$__Last6h__Lpresto_types$DashboardPeriod();
  $s_Lpresto_types$DashboardPeriod$__Last12h__Lpresto_types$DashboardPeriod();
  $s_Lpresto_types$DashboardPeriod$__Last24h__Lpresto_types$DashboardPeriod();
  $s_Lpresto_types$DashboardPeriod$__Last48h__Lpresto_types$DashboardPeriod();
  $s_Lpresto_types$DashboardPeriod$__Last7d__Lpresto_types$DashboardPeriod();
  $s_Lpresto_types$DashboardPeriod$__Last30d__Lpresto_types$DashboardPeriod();
}
export { $c_Lpresto_types$DashboardPeriod$ as $c_Lpresto_types$DashboardPeriod$ };
$p = $c_Lpresto_types$DashboardPeriod$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardPeriod$;
/** @constructor */
function $h_Lpresto_types$DashboardPeriod$() {
}
export { $h_Lpresto_types$DashboardPeriod$ as $h_Lpresto_types$DashboardPeriod$ };
$h_Lpresto_types$DashboardPeriod$.prototype = $p;
$p.cR2 = (function(\u03b4name) {
  switch (\u03b4name) {
    case "Last6h": {
      return $s_Lpresto_types$DashboardPeriod$__Last6h__Lpresto_types$DashboardPeriod();
      break;
    }
    case "Last12h": {
      return $s_Lpresto_types$DashboardPeriod$__Last12h__Lpresto_types$DashboardPeriod();
      break;
    }
    case "Last24h": {
      return $s_Lpresto_types$DashboardPeriod$__Last24h__Lpresto_types$DashboardPeriod();
      break;
    }
    case "Last48h": {
      return $s_Lpresto_types$DashboardPeriod$__Last48h__Lpresto_types$DashboardPeriod();
      break;
    }
    case "Last7d": {
      return $s_Lpresto_types$DashboardPeriod$__Last7d__Lpresto_types$DashboardPeriod();
      break;
    }
    case "Last30d": {
      return $s_Lpresto_types$DashboardPeriod$__Last30d__Lpresto_types$DashboardPeriod();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.cI1 = (function() {
  if ((!this.c56)) {
    this.c55 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$1) => _$1.l())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC);
    this.c56 = true;
  }
  return this.c55;
});
$p.csq = (function() {
  if ((!this.c58)) {
    this.c57 = new $c_Lpresto_types$DashboardPeriod$$anon$8(this);
    this.c58 = true;
  }
  return this.c57;
});
var $d_Lpresto_types$DashboardPeriod$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardPeriod$, "presto.types$DashboardPeriod$", ({
  Zf: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$DashboardPeriod$ as $d_Lpresto_types$DashboardPeriod$ };
var $n_Lpresto_types$DashboardPeriod$;
function $m_Lpresto_types$DashboardPeriod$() {
  if ((!$n_Lpresto_types$DashboardPeriod$)) {
    $n_Lpresto_types$DashboardPeriod$ = new $c_Lpresto_types$DashboardPeriod$();
  }
  return $n_Lpresto_types$DashboardPeriod$;
}
export { $m_Lpresto_types$DashboardPeriod$ as $m_Lpresto_types$DashboardPeriod$ };
var $t_Lpresto_types$DashboardPeriod$__Last6h = null;
function $u_Lpresto_types$DashboardPeriod$__Last6h(x) {
  $t_Lpresto_types$DashboardPeriod$__Last6h = x;
}
export { $t_Lpresto_types$DashboardPeriod$__Last6h as $t_Lpresto_types$DashboardPeriod$__Last6h, $u_Lpresto_types$DashboardPeriod$__Last6h as $u_Lpresto_types$DashboardPeriod$__Last6h };
var $t_Lpresto_types$DashboardPeriod$__Last12h = null;
function $u_Lpresto_types$DashboardPeriod$__Last12h(x) {
  $t_Lpresto_types$DashboardPeriod$__Last12h = x;
}
export { $t_Lpresto_types$DashboardPeriod$__Last12h as $t_Lpresto_types$DashboardPeriod$__Last12h, $u_Lpresto_types$DashboardPeriod$__Last12h as $u_Lpresto_types$DashboardPeriod$__Last12h };
var $t_Lpresto_types$DashboardPeriod$__Last24h = null;
function $u_Lpresto_types$DashboardPeriod$__Last24h(x) {
  $t_Lpresto_types$DashboardPeriod$__Last24h = x;
}
export { $t_Lpresto_types$DashboardPeriod$__Last24h as $t_Lpresto_types$DashboardPeriod$__Last24h, $u_Lpresto_types$DashboardPeriod$__Last24h as $u_Lpresto_types$DashboardPeriod$__Last24h };
var $t_Lpresto_types$DashboardPeriod$__Last48h = null;
function $u_Lpresto_types$DashboardPeriod$__Last48h(x) {
  $t_Lpresto_types$DashboardPeriod$__Last48h = x;
}
export { $t_Lpresto_types$DashboardPeriod$__Last48h as $t_Lpresto_types$DashboardPeriod$__Last48h, $u_Lpresto_types$DashboardPeriod$__Last48h as $u_Lpresto_types$DashboardPeriod$__Last48h };
var $t_Lpresto_types$DashboardPeriod$__Last7d = null;
function $u_Lpresto_types$DashboardPeriod$__Last7d(x) {
  $t_Lpresto_types$DashboardPeriod$__Last7d = x;
}
export { $t_Lpresto_types$DashboardPeriod$__Last7d as $t_Lpresto_types$DashboardPeriod$__Last7d, $u_Lpresto_types$DashboardPeriod$__Last7d as $u_Lpresto_types$DashboardPeriod$__Last7d };
var $t_Lpresto_types$DashboardPeriod$__Last30d = null;
function $u_Lpresto_types$DashboardPeriod$__Last30d(x) {
  $t_Lpresto_types$DashboardPeriod$__Last30d = x;
}
export { $t_Lpresto_types$DashboardPeriod$__Last30d as $t_Lpresto_types$DashboardPeriod$__Last30d, $u_Lpresto_types$DashboardPeriod$__Last30d as $u_Lpresto_types$DashboardPeriod$__Last30d };
//# sourceMappingURL=presto.types$-Dashboard-Period$.js.map
